var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMageDashboardBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.4062 5.84375H18.5938C11.5521 5.84375 5.84375 11.5521 5.84375 18.5938V32.4062C5.84375 39.4479 11.5521 45.1562 18.5938 45.1562H32.4062C39.4479 45.1562 45.1562 39.4479 45.1562 32.4062V18.5938C45.1562 11.5521 39.4479 5.84375 32.4062 5.84375Z",
    stroke: "white",
    strokeWidth: 3.1875
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3047 34.4718V23.6364M25.7631 34.4718V16.5283M34.6987 34.4718V20.8676",
    stroke: "white",
    strokeWidth: 3.4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMageDashboardBar);
export default __webpack_public_path__ + "static/media/mage_dashboard-bar.47eed08403d78e010baa25e81b2b5187.svg";
export { ForwardRef as ReactComponent };